export const tr = {
    'accept-button': 'Uygula',
    'no-rights': 'Öneriyi uygulama yetkiniz yok',
    'progress-accept-button': 'Uygulanıyor...'
};
